import React from 'react';
import ErrorBoundary, {ErrorBoundaryProps} from './ErrorBoundary';

/**
 * Wrap component in error boundary \
 * An error boundary catches all (un-catched) errors within its children 
 * 
 * DEVNOTE: It is advised to place an error boundary at the highest level possible \
 * Due to the nature of our app we will currently be wrapping the highest level \
 * of our components as we can (without having a react wrapper around the whole app) \
 * As we move forward and make progress we can remove the wrapper from lower levels \
 * and keep moving up the tree until (one day) we get to the top of the app
 * @example
   import Component from 'my-component';
   const ErrorBoundariedComponent = withErrorBoundary(Component);
   ...
   const MyComponent = withErrorBoundary((props: Props) => {...});
   ...
   const MyComponent = (props: Props) => {...};
   export default withErrorBoundary(MyComponent);
 */
const withErrorBoundary = function <
	C extends React.ComponentType<React.ComponentProps<C>>,
>(Component: C) {
	return (props: React.ComponentProps<C>) => {
		return (
			<ErrorBoundary>
				{/** i do not have the energy to deal with this - the most important thing is the outside world is getting proper typing */}
				<Component {...(props as any)} />
			</ErrorBoundary>
		);
	};
};

export default withErrorBoundary;
